import { ReactComponent as IconEdit } from "assets/images/icons/pencil-square.svg";
import { ReactComponent as IconSend } from "assets/images/icons/send.svg";
import ProfileCreateUpdate from "pages/Profile/ProfileCreateUpdate";
import Button from "components/ui/Button/Button";
import { useDialog } from "context/DialogContext";
import ButtonFavorite from "pages/Profile/ButtonFavorite";
import PropTypes from "prop-types";
import MessageCreate from "pages/MessageBox/MessageCreate";

function ProfileDetailActions({ profile, isOwnProfile }) {
  const { showDialog } = useDialog();

  return (
    <>
      {
        isOwnProfile
          ?
          <Button variant={ 'secondary' } onClick={ () => showDialog(<ProfileCreateUpdate/>) }>
            <IconEdit/>
            Profiel aanpassen
          </Button>
          :
          <>
            <Button variant={ 'secondary' } onClick={ () => showDialog(<MessageCreate receiver={ profile }/>) }>
              <IconSend/>
              Verstuur bericht
            </Button>

            <ButtonFavorite profileId={ profile.id }/>
          </>
      }
    </>
  );
}

ProfileDetailActions.propTypes = {
  profile: PropTypes.object.isRequired,
}

export default ProfileDetailActions;
